import gql from "graphql-tag";
import { platform } from "~/platform/socket";
import { useWidgetApp } from "~/provider";
import { i18nCache, setI18nCache } from "~/stores/i18n";

/**
 * Translate a given key to the current locale
 *
 * @param key The key to translate
 */
export async function useTranslation(key?: string): Promise<string> {
	if (!key) {
		return "";
	}

	const { locale } = useWidgetApp();

	const cacheEntry = `${locale}:${key}`;
	const translation = i18nCache.cache.get(cacheEntry);

	if (translation) {
		return translation;
	}

	const result = await platform.query(
		gql`
		query Translation($key: TranslationKey!, $locale: String!) {
			translateLocale(key: $key, locale: $locale)
		}
	`,
		{ key, locale },
	);

	if (!result?.translateLocale) {
		console.warn(`Translation for key ${key} not found`);
		return "";
	}

	setI18nCache((properties) => {
		properties.cache.set(cacheEntry, result.translateLocale);
		return { cache: properties.cache };
	});

	return result.translateLocale;
}
